module.exports = __webpack_public_path__ + "Roboto-MediumItalic.f10d1f42838680a70ac2.woff2";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-MediumItalic.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-MediumItalic.woff2
// module chunks = 13